import type { TTableAggregatedProgressBarOptions } from '@/common/components/redesigned/Table/types/tableTypes';

export const TABLE_AGGREGATED_PROGRESS_BAR_OPTIONS: TTableAggregatedProgressBarOptions = {
  title: 'Состояние загрузки',
  hintText: 'Скачивание в Excel доступно',
};
